// Ruoli Cognito e permessi del profilo responsabile, lato webapp dipendenti.
//
// Adattamento di heyjob-dash/shared/src/utils/check-permission.js: la webapp non
// ha una cartella `shared/`, quindi il file va duplicato invece che importato.

export const hasRole = (user, roles) => {
  const list = typeof roles === 'string' ? [roles] : roles;
  if (!user || !user.groups) return false;
  return list.some((role) => user.groups.includes(role));
};

// Permesso effettivo del responsabile sulla propria azienda.
//
// `GET /user` allega a ogni azienda in cui l'utente è Responsabile un oggetto
// `supervisor_permissions` risolto dal profilo assegnato, oppure — per chi non ha
// profilo — dai flag `allows_supervisor_*` dell'azienda. È lo stesso endpoint
// della dashboard, quindi il payload arriva già oggi.
//
// DIFFERENZE VOLUTE rispetto alla versione dash:
//
// 1. La chiave è `user.data.company_id` (l'azienda del dipendente) e non
//    `current_company`: quest'ultimo è stato client del company switcher della
//    dashboard e nella webapp non esiste, né lato API.
// 2. Nega **solo su un `false` esplicito**, non fail-closed. `companies` è
//    costruito da `findBySupervisor(email)`: chi supervisiona soltanto aziende
//    diverse dalla propria non ha una voce per `company_id` e l'oggetto è
//    `undefined`. Payload assente significa "non lo so", non "vietato" — e il
//    server non applica comunque il permesso, il gate qui è presentazione.
export const hasSupervisorPermission = (user, permission) => {
  if (hasRole(user, ['Azienda', 'Studio', 'Operatore'])) return true;

  if (!hasRole(user, 'Responsabile')) return false;

  const permissions = user?.data?.companies?.[user?.data?.company_id]?.supervisor_permissions;

  return permissions?.[permission] !== false;
};
